<template>
    <div 
        class="modal fade"
        id="addPazienteModal"
        tabindex="-1"
        aria-labelledby="addContact"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="addContact">
                        {{isEdit ? 'Modifica' : 'Aggiungi'}} Paziente
                    </h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                    ></button>
                </div>
                <form @submit.prevent="submit">
                <div class="modal-body">
                    <div class="col-md-12 text-start">
                        <label for="cognome" class="form-label">Cognome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.cognome ? true : false}" id="cognome" v-model="form.cognome" autofocus aria-describedby="cognomeFeedback" required>
                            <div v-if="errors.cognome" id="cognomeFeedback" class="invalid-feedback">
                                {{errors.cognome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="nome" class="form-label">Nome:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.nome ? true : false}" id="nome" v-model="form.nome" autofocus aria-describedby="nomeFeedback" required>
                            <div v-if="errors.nome" id="nomeFeedback" class="invalid-feedback">
                                {{errors.nome}}
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-start">
                        <label for="data_nascita" class="form-label">data_nascita:</label>
                        <div class="input-group has-validation">
                            <input type="date" :class="{'form-control':true, 'is-invalid':errors.data_nascita ? true : false}" id="data_nascita" v-model="form.data_nascita" autofocus aria-describedby="data_nascitaFeedback" required>
                            <div v-if="errors.data_nascita" id="data_nascitaFeedback" class="invalid-feedback">
                                {{errors.data_nascita}}
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 text-start">
                        <label for="cellulare" class="form-label">Cellulare:</label>
                        <div class="input-group has-validation">
                            <input type="tel" :class="{'form-control':true, 'is-invalid':errors.cellulare ? true : false}" id="cellulare" v-model="form.cellulare" aria-describedby="cellulareFeedback" required>
                            <div  v-if="errors.cellulare" id="cellulareFeedback" class="invalid-feedback">
                                {{errors.cellulare}}
                            </div>
                        </div>
                    </div> 

                    <div class="col-md-12 text-start">
                        <label for="email" class="form-label">Email:</label>
                        <div class="input-group has-validation">
                            <input type="email" :class="{'form-control':true, 'is-invalid':errors.email ? true : false}" id="email" v-model="form.email" autofocus aria-describedby="emailFeedback" required>
                            <div v-if="errors.email" id="emailFeedback" class="invalid-feedback">
                                {{errors.email}}
                            </div>
                        </div>
                    </div> 

                    <div class="col-md-12 text-start">
                        <label for="indirizzo" class="form-label">indirizzo:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.indirizzo ? true : false}" id="indirizzo" v-model="form.indirizzo" autofocus aria-describedby="indirizzoFeedback">
                            <div v-if="errors.indirizzo" id="indirizzoFeedback" class="invalid-feedback">
                                {{errors.indirizzo}}
                            </div>
                        </div>
                    </div> 

                    <div class="col-md-12 text-start">
                        <label for="citta" class="form-label">Città:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.citta ? true : false}" id="citta" v-model="form.citta" autofocus aria-describedby="cittaFeedback">
                            <div v-if="errors.citta" id="cittaFeedback" class="invalid-feedback">
                                {{errors.citta}}
                            </div>
                        </div>
                    </div> 

                    <div class="col-md-12 text-start">
                        <label for="cap" class="form-label">CAP:</label>
                        <div class="input-group has-validation">
                            <input type="text" :class="{'form-control':true, 'is-invalid':errors.cap ? true : false}" id="cap" v-model="form.cap" autofocus aria-describedby="capFeedback">
                            <div v-if="errors.cap" id="capFeedback" class="invalid-feedback">
                                {{errors.cap}}
                            </div>
                        </div>
                    </div> 
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-bs-dismiss="modal"
                    >
                        Annulla
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="form.processing">
                        {{isEdit ? 'Aggiorna' : 'Salva'}}
                    </button>
                </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';

export default {
    props: {
        paziente: Object,
        isEdit: Boolean
    },
    data() {
        return {
            modal: null,
            form: this.$inertia.form({
                cognome: this.paziente ? this.paziente.cognome : "" ,
                nome: this.paziente ? this.paziente.nome : "" ,
                data_nascita: this.paziente ? this.paziente.data_nascita : "" ,
                cellulare: this.paziente ? this.paziente.cellulare : "",
                email: this.paziente ? this.paziente.email : "",
                indirizzo: this.paziente ? this.paziente.indirizzo : "",
                citta: this.paziente ? this.paziente.citta : "",
                cap: this.paziente ? this.paziente.cap : ""
            }),
            errors: {
               cognome: null,
               nome: null,
               data_nascita: null,
               cellulare: null,
               email: null,
               indirizzo: null,
               citta: null,
               cap: null
            },
        };
    },
    mounted() {
        var modalEl = document.getElementById('addPazienteModal')
        this.modal = new Modal(modalEl)
        this.modal.show();
        
        modalEl.addEventListener('hidden.bs.modal',  (event) => {
            this.$emit('modelStatusChanged',false)
        })
    },
    methods: {
        close(){
            //this.isOpen = false
        },
        submit() {
            let route = this.isEdit ? this.route("pazienti.update",this.paziente.id) : this.route("pazienti.store")
            let method = this.isEdit ? 'patch' : 'post'
            this.form[this.isEdit ?'patch' : 'post'](route, {
                onError: (errors) => {
                    
                    if (Object.entries(errors).length !== 0) {
                        var toast = {
                            bg: "bg-danger",
                        };

                        if (errors.hasOwnProperty("cognome")) {
                            toast.message = errors.cognome;
                            this.errors.cognome = errors.cognome;
                        }

                        if (errors.hasOwnProperty("nome")) {
                            toast.message = errors.nome;
                            this.errors.nome = errors.nome;
                        }

                        if (errors.hasOwnProperty("cellulare")) {
                            toast.message = errors.cellulare;
                            this.errors.cellulare = errors.cellulare;
                        }

                        if (errors.hasOwnProperty("email")) {
                            toast.message = errors.email;
                            this.errors.email = errors.email;
                        }
                    }
                }, 
                onSuccess: () => {
                    this.form.reset();
                    this.modal.hide();

                }
            });
        },
    },
};
</script>
